import { render, staticRenderFns } from "./c_checkbox.vue?vue&type=template&id=6da809a3&scoped=true"
import script from "./c_checkbox.vue?vue&type=script&lang=js"
export * from "./c_checkbox.vue?vue&type=script&lang=js"
import style0 from "./c_checkbox.vue?vue&type=style&index=0&id=6da809a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da809a3",
  null
  
)

export default component.exports